<template>
  <div class="d-flex justify-start align-center ">
    <ConfirmAssignTable
      :state="confirmMarkDialog"
      :importedDocuments="importedDocuments"
      :examId="query.exam"
      @closeDialog="closeConfirmDialog"
      @refresh="refresh"
      ref="absentDialog"
      :all="true"
    />
    <div>
      <v-menu open-on-hover bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mt-0" color="green" dark v-bind="attrs" v-on="on" outlined>
            Nhập/xuất Excel
          </v-btn>
        </template>

        <v-list>
          <v-list-item class="cursor-pointer">
            <v-list-item-title @click="onUploadClick">Tải lên tệp Excel phân chấm thi</v-list-item-title>
            <input
              ref="uploader"
              type="file"
              class="d-none"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              @change="onFileChanged"
            />
          </v-list-item>
          <v-list-item class="cursor-pointer">
            <v-list-item-title @click="exportDataToExcel">Tải xuống tệp Excel mẫu</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <v-spacer></v-spacer>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { mapActions } from 'vuex'
import XLSX from 'xlsx-js-style'
import readXlsxFile from 'read-excel-file'
import { RoomSubject } from '../../plugins/api'
import ConfirmAssignTable from './ConfirmAssignTable.vue'

export default {
  props: {
    room: Object,
    query: Object,
    exam: Object,
    subjects: Array
  },
  data() {
    return {
      loading: false,
      confirmMarkDialog: false,
      importedDocuments: [],
      marks: [],
      markMapping: {
        absent: 'Vắng thi',
        present: 'Có thi',
        emtpy: 'Không biên bản',
        suspended: 'VPQC'
      }
    }
  },
  components: { ConfirmAssignTable },
  computed: {},
  mounted() {},
  methods: {
    ...mapActions('examMark', ['fetchMarks', 'countMarks']),
    ...mapActions('exam', ['updateExam']),
    formatDataForExport(data) {
      // Get headers dynamically based on data (including subjects)
      const headers = this.getHeaders(data)

      return data.map((item, index) => {
        let formattedItem = {}

        headers.forEach(key => {
          let value = item[key] || '' // Default to empty string if value doesn't exist

          // Add STT (Serial Number) to the first column
          if (key === 'STT') {
            value = index + 1 // STT starts from 1
            formattedItem[key] = { v: value, t: 's' }
          } else {
            // Handle normal fields
            formattedItem[key] = value !== undefined && value !== null ? value : ''
          }
        })

        return formattedItem
      })
    },
    async exportDataToExcel() {
      const marks = await RoomSubject.getAssignExcel({ exam: this.query.exam })
      const formattedData = this.formatDataForExport(marks)
      const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true })
      const headers = [
        ['Trường THCS và THPT Tạ Quang Bửu', ''],
        [`PHÂN CÔNG CHẤM THI`, ''],
        [``, ''],
        [``, '']
      ]
      const signatureRow = formattedData.length + 7

      headers.forEach((header, rowIndex) => {
        const cellAddress = `A${rowIndex + 1}`
        worksheet[cellAddress] = { v: header[0], t: 's' }

        if (rowIndex === 0 || rowIndex === 2 || rowIndex === 3) {
          worksheet[cellAddress].s = {
            font: { bold: true, sz: 13, name: 'Times New Roman' },
            alignment: { horizontal: 'left', vertical: 'center' }
          }
        }

        if (rowIndex === 1) {
          worksheet[cellAddress].s = {
            font: { bold: true, sz: 14, name: 'Times New Roman' },
            alignment: { horizontal: 'center', vertical: 'center', wrapText: true }
          }
        }
      })
      // Set column widths for columns B and C
      worksheet['!cols'] = [
        { wch: 8 }, // Column A width
        { wch: 25 }, // Column C width
        { wch: 35 }, // Column B width
        { wch: 17 }, // Column D width
        { wch: 15 }, // Column E width
        { wch: 15 }, // Column E width
        { wch: 15 }, // Column E width
        { wch: 15 }, // Column E width
        { wch: 15 }, // Column E width
        { wch: 15 }, // Column E width
        { wch: 15 } // Column E width
      ]
      // Define common styles for headers and data cells
      const dynamicHeaders = this.getHeaders(marks)
      worksheet['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: dynamicHeaders.length - 1 } }, // Merge row 1
        { s: { r: 1, c: 0 }, e: { r: 1, c: dynamicHeaders.length - 1 } }, // Merge row 2
        { s: { r: 2, c: 0 }, e: { r: 2, c: dynamicHeaders.length - 1 } }, // Merge row 3
        { s: { r: 3, c: 0 }, e: { r: 3, c: dynamicHeaders.length - 1 } } // Merge row 4
      ]

      // Define styles for headers and data cells
      const headerStyle = {
        font: { bold: true, sz: 12, name: 'Times New Roman' },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: { top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } }
      }
      const dataStyle = {
        font: { sz: 12, name: 'Times New Roman' },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: { top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } }
      }

      // Add the actual table data starting from A5
      XLSX.utils.sheet_add_json(worksheet, formattedData, {
        origin: 'A5',
        header: dynamicHeaders,
        skipHeader: false
      })

      // Apply header and data styles
      dynamicHeaders.forEach((header, colIndex) => {
        const colLetter = String.fromCharCode(65 + colIndex) // Convert column index to letter (A, B, C, ...)
        const headerCellAddress = `${colLetter}5`

        // Apply styles to header cells
        if (worksheet[headerCellAddress]) {
          worksheet[headerCellAddress].s = headerStyle
        }

        // Apply data styles to all rows
        if (formattedData.length > 0) {
          for (let rowIndex = 6; rowIndex < formattedData.length + 6; rowIndex++) {
            const dataCellAddress = `${colLetter}${rowIndex}`

            if (worksheet[dataCellAddress]) {
              worksheet[dataCellAddress].s = dataStyle
            }
          }
        }
      })

      const endRow = signatureRow + 6
      worksheet['!ref'] = `A1:${String.fromCharCode(65 + dynamicHeaders.length - 1)}${endRow}`

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Điểm')
      XLSX.writeFile(workbook, `Phân công chấm thi.xlsx`)

      this.$loading.active = false
    },
    getHeaders(data) {
      // Extract the headers from the first item in the data
      const firstItem = data[0] || {}

      // Collect all fixed fields first
      const headers = ['STT']

      // Dynamically add subjects to the headers
      Object.keys(firstItem).forEach(key => {
        if (!headers.includes(key)) {
          headers.push(key) // This includes subject marks
        }
      })

      return headers
    },
    onUploadClick() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },

    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let rows, headers
      try {
        // Read the entire file
        const rawRows = await readXlsxFile(this.selectedFile)

        // Start from the 5th item (A5)
        headers = rawRows[4].map(header => (header === 'Phòng' ? 'room' : header))
        rows = rawRows.slice(5).map(row => {
          let rowData = {}
          row.forEach((value, index) => {
            rowData[headers[index]] = value
          })
          return rowData
        })
      } catch (error) {
        console.error(error)
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }

      // Assign data to importedDocuments and update UI
      this.importedDocuments = rows
      this.confirmMarkDialog = true
      this.$loading.active = false
      this.$alert.success('Đã đọc File thành công!')
    },
    closeConfirmDialog() {
      this.confirmMarkDialog = false
      this.$refs.uploader.value = null
    },
    refresh() {
      this.$emit('refresh')
    }
  },
  watch: {}
}
</script>
